import { render } from "./Measuring.vue?vue&type=template&id=16f84695"
import script from "./Measuring.vue?vue&type=script&lang=js"
export * from "./Measuring.vue?vue&type=script&lang=js"

import "./Measuring.vue?vue&type=style&index=0&id=16f84695&lang=css"

import exportComponent from "/home/oawms/app/ru_releases/20261004163500/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QCarousel from 'quasar/src/components/carousel/QCarousel.js';
import QCarouselSlide from 'quasar/src/components/carousel/QCarouselSlide.js';
import QSlideTransition from 'quasar/src/components/slide-transition/QSlideTransition.js';
import QInput from 'quasar/src/components/input/QInput.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import qInstall from "../../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QCarousel,QCarouselSlide,QSlideTransition,QInput,QBtn});
